<template>
  <!--
    「요금·결제」 창들의 날짜·시각 칸 한 곳(체험 기간 정하기·매장 체험·지정 끝·이용 기간 늘리기 — 설계안 §25). 고른 값은 KST 벽시계
    글자(`KST_PICK_FORMAT`)이고 보낼 ISO 는 요청 함수가 만든다. 아래 끝(`floorMs`, 비면 지금)의 KST 날짜보다 앞선 날은 고르지 못한다 —
    그 날 안의 앞선 시각은 요청 함수가 거른다. 판정은 `utils/subscriptionAdmin` 의 `pickDayDisabled`.
  -->
  <el-date-picker
    :value="value"
    class="subscription-moment"
    type="datetime"
    :format="format"
    :value-format="format"
    :picker-options="pickerOptions"
    :placeholder="$t(text.pickMoment)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"></el-date-picker>
</template>

<script>
import { KST_PICK_FORMAT, SUBSCRIPTION_TEXT, pickDayDisabled } from '@/utils/subscriptionAdmin'

export default {
  name: 'SubscriptionMomentPicker',

  props: {
    /** 고른 값(`2026-11-05 09:00`) — 비었으면 빈 글자 */
    value: { type: String, default: '' },
    /** 아래 끝(epoch ms) — 비면 달력을 그릴 때의 지금 */
    floorMs: { type: Number, default: null },
  },

  data: function () {
    return {
      text: SUBSCRIPTION_TEXT,
      format: KST_PICK_FORMAT,
      // 달력이 칸을 그릴 때마다 시계를 읽는다(경계) — 판정은 순수 함수
      pickerOptions: {
        disabledDate: (date) => pickDayDisabled(date, this.floorMs === null ? Date.now() : this.floorMs),
      },
    }
  },
}
</script>

<style scoped>
.subscription-moment {
  display: block;
  width: 220px;
}
</style>
